import client from '../client';

export type TApiArea = {
  id: number;
  name: string;
  value: Array<string>;
  north: string;
  west: string;
  south: string;
  east: string
}

const list = (): Promise<Array<TApiArea>> =>
  client.get('/area/').then(response => response.data);

export {
  list
};
